import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Page from '../../components/Page';
import RegisterStudent from '../../sections/auth/register/RegisterStudent';

// Premium CSS overrides for the existing RegisterStudent component
const premiumStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800;900&display=swap');

  .cool-student-wrapper {
    font-family: 'Inter', sans-serif;
    background: linear-gradient(180deg, #f0f4ff 0%, #e8ecf8 50%, #f5f0ff 100%);
    min-height: 100vh;
    padding-bottom: 60px;
  }

  /* ===== HERO BANNER ===== */
  .cool-student-hero {
    background: linear-gradient(135deg, #0a0e27 0%, #1a1a3e 40%, #0c366d 100%);
    padding: 40px 0 50px;
    margin-bottom: 40px;
    position: relative;
    overflow: hidden;
  }
  .cool-student-hero::before {
    content: '';
    position: absolute;
    width: 400px; height: 400px;
    border-radius: 50%;
    top: -200px; right: -100px;
    background: radial-gradient(circle, rgba(0,212,255,0.15) 0%, transparent 70%);
  }
  .cool-student-hero::after {
    content: '';
    position: absolute;
    width: 300px; height: 300px;
    border-radius: 50%;
    bottom: -150px; left: -80px;
    background: radial-gradient(circle, rgba(123,47,247,0.15) 0%, transparent 70%);
  }

  /* ===== PROFILE CARDS ===== */
  .cool-student-wrapper .MuiCard-root {
    border-radius: 20px !important;
    border: 1px solid rgba(123, 47, 247, 0.08);
    box-shadow: 0 8px 32px rgba(0,0,0,0.06) !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease !important;
    overflow: visible !important;
  }
  .cool-student-wrapper .MuiCard-root:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 48px rgba(123, 47, 247, 0.12) !important;
  }

  /* Profile cards gradient override */
  .cool-student-wrapper > .MuiContainer-root > div:first-of-type > .MuiCard-root {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: #fff !important;
  }
  .cool-student-wrapper > .MuiContainer-root > div:first-of-type > .MuiCard-root .MuiTypography-root {
    color: rgba(255,255,255,0.9) !important;
  }
  .cool-student-wrapper > .MuiContainer-root > div:first-of-type > .MuiCard-root h3 {
    color: #fff !important;
  }
  .cool-student-wrapper > .MuiContainer-root > div:first-of-type > .MuiCard-root .MuiButton-root {
    color: #fff !important;
    font-weight: 700;
  }

  /* ===== FORM FIELDS ===== */
  .cool-student-wrapper .MuiTextField-root .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255,255,255,0.8);
    backdrop-filter: blur(8px);
    transition: all 0.3s ease;
  }
  .cool-student-wrapper .MuiTextField-root .MuiOutlinedInput-root:hover {
    background: #fff;
    box-shadow: 0 4px 20px rgba(123, 47, 247, 0.08);
  }
  .cool-student-wrapper .MuiTextField-root .MuiOutlinedInput-root.Mui-focused {
    background: #fff;
    box-shadow: 0 4px 20px rgba(123, 47, 247, 0.15);
  }
  .cool-student-wrapper .MuiTextField-root .MuiOutlinedInput-notchedOutline {
    border-color: rgba(123, 47, 247, 0.15) !important;
  }
  .cool-student-wrapper .MuiTextField-root .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #7b2ff7 !important;
    border-width: 2px !important;
  }
  .cool-student-wrapper .MuiInputLabel-root.Mui-focused {
    color: #7b2ff7 !important;
  }

  /* ===== SELECT FIELDS ===== */
  .cool-student-wrapper .MuiFormControl-root .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255,255,255,0.8);
  }

  /* ===== CHIPS ===== */
  .cool-student-wrapper .MuiChip-root {
    border-radius: 10px !important;
    font-weight: 600 !important;
    background: linear-gradient(135deg, #667eea, #764ba2) !important;
    color: #fff !important;
  }
  .cool-student-wrapper .MuiChip-deleteIcon {
    color: rgba(255,255,255,0.7) !important;
  }

  /* ===== BUTTONS ===== */
  .cool-student-wrapper .MuiButton-contained {
    border-radius: 12px !important;
    text-transform: none !important;
    font-weight: 700 !important;
    padding: 10px 24px !important;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
    transition: all 0.3s ease !important;
  }
  .cool-student-wrapper .MuiButton-contained:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
  }
  .cool-student-wrapper .MuiLoadingButton-root {
    background: linear-gradient(45deg, #00d4ff, #7b2ff7) !important;
    border-radius: 14px !important;
    font-size: 1rem !important;
    padding: 12px 32px !important;
    font-weight: 800 !important;
  }

  /* ===== TABLE SECTION HEADERS ===== */
  .cool-student-wrapper .MuiCard-root > .MuiStack-root > h4 {
    background: linear-gradient(90deg, #ff6b6b, #7b2ff7) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    font-weight: 800 !important;
    font-size: 1.4rem !important;
  }

  /* ===== TABLE STYLING ===== */
  .cool-student-wrapper .MuiTableHead-root {
    background: linear-gradient(135deg, #0c366d 0%, #1a1a3e 100%) !important;
  }
  .cool-student-wrapper .MuiTableHead-root .MuiTableCell-head {
    color: #fff !important;
    font-weight: 700 !important;
    font-size: 0.8rem !important;
    letter-spacing: 0.5px;
    border-bottom: none !important;
  }
  .cool-student-wrapper .MuiTableHead-root .MuiTableSortLabel-root {
    color: #fff !important;
  }
  .cool-student-wrapper .MuiTableBody-root .MuiTableRow-root {
    transition: background 0.2s ease;
  }
  .cool-student-wrapper .MuiTableBody-root .MuiTableRow-root:hover {
    background: rgba(123, 47, 247, 0.04) !important;
  }
  .cool-student-wrapper .MuiTableBody-root .MuiTableCell-root {
    border-bottom: 1px solid rgba(123, 47, 247, 0.06) !important;
    font-size: 0.85rem;
  }

  /* ===== AVATAR ===== */
  .cool-student-wrapper .MuiAvatar-root {
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
    border: 3px solid rgba(255,255,255,0.3);
  }

  /* ===== DIALOG / MODAL ===== */
  .cool-student-wrapper .MuiDialog-paper {
    border-radius: 20px !important;
    padding: 8px;
  }

  /* ===== DATE PICKER ===== */
  .cool-student-wrapper .MuiPickersDay-root.Mui-selected {
    background: #7b2ff7 !important;
  }

  /* ===== SCROLLBAR ===== */
  .cool-student-wrapper ::-webkit-scrollbar {
    width: 6px; height: 6px;
  }
  .cool-student-wrapper ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea, #764ba2);
    border-radius: 3px;
  }

  /* ===== ANIMATIONS ===== */
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .cool-student-wrapper .MuiContainer-root {
    animation: fadeInUp 0.6s ease-out;
  }
`;

export default function CoolStudentInfo() {
  return (
    <Page title="Student Info - Premium">
      <style>{premiumStyles}</style>
      <Box className="cool-student-wrapper">
        {/* Premium Hero Banner */}
        <Box className="cool-student-hero">
          <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
            <Typography sx={{
              fontSize: '0.85rem', color: '#00d4ff', fontWeight: 700,
              letterSpacing: 3, textTransform: 'uppercase', mb: 1,
            }}>
              Student Management
            </Typography>
            <Typography sx={{
              fontSize: { xs: '1.6rem', md: '2.4rem' }, fontWeight: 900, color: '#fff',
              lineHeight: 1.2, mb: 1,
            }}>
              Student Profile &{' '}
              <Box component="span" sx={{
                background: 'linear-gradient(90deg, #00d4ff, #7b2ff7)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              }}>Registration</Box>
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.95rem' }}>
              View and manage student details, payments, courses, and exam performance
            </Typography>
          </Container>
        </Box>

        {/* Existing RegisterStudent with premium styling applied via CSS */}
        <Container maxWidth="lg">
          <RegisterStudent />
        </Container>
      </Box>
    </Page>
  );
}
